import React, { useState, useEffect } from 'react'
import api from '../components/api'
import { dataTableRender, cor, corEnviado, rotulo, rotuloEnviado } from '../components/functions'
import ModalCompras from '../modals/compras'


const TabelaGestao = (props) => {

    var adesao_institucional_id = props.adesao_institucional_id
    var [resultadoCompras, setResultadoCompras] = useState()
    var [ano, setAno] = useState()

    

    

    async function compras() {

        await api.get(`comprasTabelaGestao/${adesao_institucional_id}`).then((result) => {

           //console.log(result.data)
           setResultadoCompras(result.data.map((rs) =>
           
               <tr data-toggle="modal" style={{cursor: 'pointer' }} data-target="#modalCompras" onClick={() => setAno(rs.anoPerfil)}>
                   <td>
                       <center>
                       {rs.anoPerfil ? rs.anoPerfil : rs.anoCompras}
                       </center>
                   </td>
                   <td style={{ backgroundColor: cor(rs.secaoI) }}>
                       <center>
                       {rotulo(rs.secaoI)}
                       </center>
                   </td>
                   <td style={{ backgroundColor: cor(rs.secaoII)}}>
                       <center>
                       {rotulo(rs.secaoII)}
                       </center>
                   </td>
                   <td style={{ backgroundColor: cor(rs.secaoIII)}}>
                       <center>
                       {rotulo(rs.secaoIII)}
                       </center>
                   </td>
                   <td style={{ backgroundColor: cor(rs.secaoIV)}}>
                       <center>
                       {rotulo(rs.secaoIV)}
                       </center>
                   </td>
                   <td style={{ backgroundColor: corEnviado(rs.situacaoEnviado)}}>
                       <center>
                       {rotuloEnviado(rs.situacaoEnviado)}
                       </center>
                   </td>
                   <td>
                       <center>
                       {rs.dataEnvio}
                       </center>
                   </td>

               </tr>
           
           ))

           dataTableRender('tabelaCompras')

       }).catch((err) => {

           console.log(err.response)

       })

       


   }


    useEffect(() => {

        compras()

    }, [])


    var adesao_institucional_id = props.adesao_institucional_id


    return (

        <div>

            <div className="table-responsive">
                <table id="tabelaCompras" className="table table-bordered table-striped table-hover">
                <thead>
                        <tr>
                            <th><center>Ano</center></th>
                            <th><center>Seção I</center></th>
                            <th><center>Seção II</center></th>
                            <th><center>Seção III</center></th>
                            <th><center>Seção IV</center></th>
                            <th><center>Situação</center></th>
                            <th><center>Enviado em</center></th>                                                    
                            
                        </tr>
                    </thead>
                    <tbody>
                        {resultadoCompras}
                    </tbody>
                    
                </table>
            
            </div>

            <ModalCompras adesao_institucional_id={adesao_institucional_id} ano={ano} fnCompras={compras} />

        </div>
    )

    

}


export default TabelaGestao